import {useLocation, Navigate} from 'react-router-dom'
import { useContext } from "react";
import { AuthContext } from "../context/authContext";


const RequireSuperAdmin = ({children}: {children: React.ReactElement}) => {
    const location = useLocation()
    const { currentUser }: any = useContext(AuthContext);



    if(currentUser )
    {
        if(currentUser.admin !==2 ) return <Navigate to="/" state={{from: location}}/>

        return children
    }

    return <Navigate to="/" state={{from: location}}/>
}


export default RequireSuperAdmin